import { useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'

import { useFormikContext } from 'formik'

import { CustomerFormModel } from '../model/customer.model'
import { selectCustomerFromClientSearch } from '../store/customer.selectors'

import { selectNationalities } from '~/masterData/store/masterData.selectors'
import { selectIsCartera } from '~/sale/store/sale.selectors'

export default function useClientFieldValues() {
  const { isValid, setFieldTouched, values, setValues } = useFormikContext<CustomerFormModel>()
  const { contactPhone } = values
  const isCartera = useSelector(selectIsCartera)
  const customerValuesFromClientSearch = useSelector(selectCustomerFromClientSearch)
  const nationalities = useSelector(selectNationalities)

  function checkExistentCustomerValues(field: string) {
    return isCartera && !!Object.keys(customerValuesFromClientSearch).find((el) => el === field)
  }

  const shouldSetValues = useMemo(() => customerValuesFromClientSearch && !!nationalities?.length, [
    customerValuesFromClientSearch,
    nationalities,
  ])

  useEffect(() => {
    if (shouldSetValues) {
      setValues(customerValuesFromClientSearch)
    }
  }, [shouldSetValues])

  useEffect(() => {
    if (isValid && contactPhone) {
      setFieldTouched('contactPhone', true)
    }
  }, [isValid, contactPhone])

  return { checkExistentCustomerValues }
}
